<div class="content">
  @if ((children?.length || 0) > 0) {
    <div class="treeHeader" (click)="toggleExpansion()">
      <mat-icon class="size-16">{{ expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
      <label class="titleLabel">{{ node().displayName }}</label>
    </div>
  }
  @if ((children?.length || 0) === 0) {
    <div class="treeHeader">
      <mat-icon class="size-16"></mat-icon>
      <label class="downloadLink" (click)="requestDownload(node())">{{ node().displayName }}</label>
      @if (sharingAllowed()) {
        <button matButton="text" class="shareButton" (click)="shareFile(node())">
          <span>
            <mat-icon class="size-12">share</mat-icon>
            <label class="buttonLabel">Share</label>
          </span>
        </button>
      }
    </div>
  }
  @if (expanded) {
    <div class="childNodes">
      @for (child of children; track child) {
        <div class="nodeWrapper">
          <app-documentation-node [node]="child" [sharingAllowed]="sharingAllowed()" (shareRequested)="shareFile($event)"
          (downloadRequested)="requestDownload($event)"></app-documentation-node>
        </div>
      }
    </div>
  }
</div>
